"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSamplesRecursive = void 0;
const axios_1 = __importDefault(require("axios"));
class Configuration {
    constructor() {
        this.id = -1;
        this.name = '';
        this.shared = false;
        this.mine = false;
    }
    async delete() {
        await axios_1.default.delete(`/toolkit/heatmap/api/saved_configurations/${this.id}`);
    }
    static fromRaw(raw) {
        const configuration = new Configuration;
        configuration.id = raw.id;
        configuration.name = raw.name;
        configuration.shared = raw.shared;
        configuration.mine = raw.mine;
        configuration.data = raw.data;
        configuration.creator = raw.creator;
        return configuration;
    }
    static async saveNew(name, shared, configuration) {
        const payload = {
            name,
            shared,
            data: JSON.stringify(configuration),
        };
        await axios_1.default.post('/toolkit/heatmap/api/saved_configurations', payload);
    }
    static async loadList() {
        const items = (await axios_1.default.get('/toolkit/heatmap/api/saved_configurations')).data;
        return items.map((x) => Configuration.fromRaw(x));
    }
}
exports.default = Configuration;
function getSamplesRecursive(groupConfig) {
    if (groupConfig.samples) {
        return groupConfig.samples;
    }
    let samples = [];
    if (groupConfig.groups) {
        groupConfig.groups.forEach(groupConfig => {
            samples = [...samples, ...getSamplesRecursive(groupConfig)];
        });
    }
    return samples;
}
exports.getSamplesRecursive = getSamplesRecursive;
